import { render } from "./feeCard.vue?vue&type=template&id=36ec1b5c&scoped=true"
import script from "./feeCard.vue?vue&type=script&lang=js"
export * from "./feeCard.vue?vue&type=script&lang=js"

import "./feeCard.vue?vue&type=style&index=0&id=36ec1b5c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ec1b5c"]])

export default __exports__